const initialConfig = (
  url: string,
  data: any, //todo
  accessToken: string
) => ({
  method: 'post',
  url,
  headers: {
    Authorization: 'Bearer ' + accessToken,
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
  data,
});

export default initialConfig;
